export default __webpack_public_path__ + "static/media/banner_video2.d955ec33.mp4";